import { createClient, SupabaseClient } from '@supabase/supabase-js';

let supabaseClient: SupabaseClient | null = null;

/**
 * Get Supabase client - requires env vars to be set
 * @throws Error if required environment variables are missing
 */
export function getSupabaseClient(): SupabaseClient {
  // If already initialized, return it
  if (supabaseClient) {
    return supabaseClient;
  }

  // Check if required env vars exist
  const url = process.env.REACT_APP_SUPABASE_URL;
  const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

  // Check if env vars are missing
  if (!url || !anonKey) {
    const errorMsg = 'Missing Supabase env vars: REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY. ' +
      'Note: Environment variables must be set BEFORE building. If you added them after deployment, trigger a new build.';
    console.error('[Supabase]', errorMsg);
    throw new Error(errorMsg);
  }

  // Initialize Supabase client
  supabaseClient = createClient(url, anonKey, {
    auth: {
      persistSession: true,
      detectSessionInUrl: true,
    },
  });

  return supabaseClient;
}

